/**
 * Styled Components - Created by miguelcanobbio on 06/07/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  color: #5f6062;
  font-size: 18px;
  font-weight: 600;

  .ant-modal-header {
    padding: 16px 24px;
    border-radius: 4px 4px 0 0;
    background: #fff;
    color: rgba(0, 0, 0, 0.65);
    border-bottom: null;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ModalTitle/styledComponents.tsx